import { render, staticRenderFns } from "./LoadingVue.vue?vue&type=template&id=c89d36d6"
import script from "./LoadingVue.vue?vue&type=script&lang=js"
export * from "./LoadingVue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports